/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 16:48:53
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/alert.js
 */
export default {
    // alert警告组件
    alert: {
        title: '',
        type: 'warning',
        description: '',
        closable: false,
        showIcon: false,
        effect: 'light',
        center: false,
        fontSize: 14
    }
}
